export default __webpack_public_path__ + "static/media/consuelo-klein-reyes.91d40db9.jpg";